import { createAsyncThunk } from '@reduxjs/toolkit';
import TagManager from 'react-gtm-module';

import { LoadingType, RootState, setContractorPortalData, setLoadingState } from 'actions';
import { setContractorPortalStep } from 'actions/stages';
import IntermediaryApplicationsApi from 'api/IntermediaryApplicationsApi';
import { ContractorPortalStep } from 'enums/ContractorPortalStep';
import { IntermediaryVariables } from 'enums/IntermediaryVariables';
import { FailureNotificationType } from 'notifications';
import * as notificationManager from 'notifications';
import { IntermediaryApplicationProps } from 'api/IntermediaryApplicationsApi';
import { GOOGLE_TAG_MANAGER_ARGS } from 'constants/constants';

export const saveContractorApplicationThunk = (intermediaryApplicationApi: IntermediaryApplicationsApi) =>
  createAsyncThunk(
    'contractor/createApplication',
    async (application: IntermediaryApplicationProps, { dispatch, getState }) => {
      try {
        const { data } = getState() as RootState;

        dispatch(setLoadingState({ type: LoadingType.CreateIntermediary, loading: true }));

        const { csm, created, alreadyExistingEmail } = await intermediaryApplicationApi.createIntermediaryApplication({
          contractorApplication: application,
          generalData: {
            [IntermediaryVariables.SourceType]: data.howDidYouHearAboutUs,
            [IntermediaryVariables.SourceName]: data.howDidYouHearAboutUsComment,
            [IntermediaryVariables.UTMSource]: data.utmSource,
            [IntermediaryVariables.UTMMedium]: data.utmMedium,
            [IntermediaryVariables.UTMCampaign]: data.utmCampaign,
            [IntermediaryVariables.CampaignID]: data.campaignId,
            [IntermediaryVariables.ADGroupID]: data.adGroupId,
            [IntermediaryVariables.Network]: data.network,
            [IntermediaryVariables.Device]: data.device,
            [IntermediaryVariables.Refer]: (data.refer || '').toLowerCase(),
            intermediary_prequal_link_used: application.intermediary_prequal_link_used,
          },
        });

        dispatch(
          setContractorPortalData({
            csm: csm,
            created: created,
          }),
        );

        if (alreadyExistingEmail) {
          dispatch(setContractorPortalStep(ContractorPortalStep.ContractorApplication));
          dispatch(setContractorPortalData({ isEmailError: true }));

          return notificationManager.notifyFailure(
            FailureNotificationType.ContractorEmailAlreadyExists,
            alreadyExistingEmail,
          );
        }

        if (created) {
          TagManager.dataLayer(GOOGLE_TAG_MANAGER_ARGS.contractorApplication);

          return dispatch(setContractorPortalStep(ContractorPortalStep.Congratulations));
        } else {
          return dispatch(
            setContractorPortalStep(
              csm ? ContractorPortalStep.AlreadySetUpWithCSM : ContractorPortalStep.AlreadySetUpWithoutCSM,
            ),
          );
        }
      } catch (error: any) {
        dispatch(setContractorPortalData({ alreadyExistingEmail: undefined }));
        notificationManager.notifyFailure(FailureNotificationType.UnknownError);
      } finally {
        dispatch(setLoadingState({ type: LoadingType.CreateIntermediary, loading: false }));
      }
    },
  );
